'use client'
import { WalletConnectConnector } from '../WalletConnectConnector/WalletConnectConnector.js';

const getWalletConnectConnector = () => class extends WalletConnectConnector {
    constructor(props) {
        super(Object.assign(Object.assign({}, props), { walletName: 'WalletConnect' }));
    }
};

export { getWalletConnectConnector };
